module.exports = __webpack_public_path__ + "static/media/Tw3.c449e84b.jpeg";